import React from 'react';
import { questionModalMetadata, requestedDocumentModalMetadata } from 'common/constants/firms';
import FormInput from './FormInput';
import { RequestItemModalContentProps } from './types';

const RequestItemModalContent: React.FC<RequestItemModalContentProps> = ({
  isDocumentRequest,
  formValues,
  setFormValues,
  setIsMaxCharactersError,
  hideDescription,
  children,
}) => {
  const formStructure = isDocumentRequest ? requestedDocumentModalMetadata : questionModalMetadata;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div>
      <FormInput
        name="name"
        label={formStructure.name}
        placeholder={formStructure.namePlaceholder}
        value={formValues.name}
        handleInputChange={handleInputChange}
        type="textarea"
        maxCharacters={100}
        setIsMaxCharactersError={setIsMaxCharactersError}
      />
      {!hideDescription && (
        <FormInput
          name="description"
          label={formStructure.description}
          placeholder={formStructure.descriptionPlaceholder}
          value={formValues.description ?? ''}
          handleInputChange={handleInputChange}
          type="textarea"
          maxCharacters={200}
          setIsMaxCharactersError={setIsMaxCharactersError}
        />
      )}
      {children}
    </div>
  );
};

export default RequestItemModalContent;
